module.exports = __webpack_public_path__ + "img/logo-cred-jb.e43e1003.jpg";